

import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import SettingEntity from '@/services/Internal-Tickets/interfaces/setting.entity';
import InternalTicketsRepositoryInterface, { SettingType } from '@/services/Internal-Tickets/interfaces';

@Component({
  inject: ['internalTicketsRepository']
})
export default class TicketSettingsEditDialog extends Vue {

  @Prop() dialogVisible: boolean;
  @Prop() settingType: SettingType;
  @Prop() setting: SettingEntity

  private name:string = ''
  private color:string = ''

  private readonly internalTicketsRepository: InternalTicketsRepositoryInterface;

  public cancelOption() {
    this.$emit('cancelEditDialog', false);
  }

  @Watch('setting', { immediate: true })
  private onSettingChanged(newSetting: SettingEntity) {
    this.name = newSetting.name;
    this.color = newSetting.color;
  }

  public async saveOption(selectedOption: string) {
    const settingId = this.setting.id
    if (this.settingType === SettingType.PRIORITY) {
      await this.internalTicketsRepository.updateSetting(this.settingType,settingId,{name: this.name, color: this.color} );
    }
    else if (this.settingType === SettingType.COMPONENT) {
      await this.internalTicketsRepository.updateSetting(this.settingType,settingId, {name: this.name, color: this.color});
    }
    else if (this.settingType === SettingType.STATUS) {
      await this.internalTicketsRepository.updateSetting(this.settingType,settingId, {name: this.name, color: this.color});
    }
    this.name = ''
    this.color = ''
    this.$emit('refreshSetting',this.settingType)
  }

}
